import { Menu } from "lucide-react";
import { Logo } from "../../icons";
import { Button } from "../ui/button";
import { useSidebar } from "../ui/sidebar";

export const Header = () => {
  const { setOpenMobile } = useSidebar();

  const isProduction = import.meta.env.MODE === "production";

  return (
    <div className="fixed top-0 right-0 left-0 z-20 flex h-(--header-height) flex-col">
      {!isProduction && (
        <header className="relative flex h-8 items-center bg-rose-600 px-3 text-white 2xl:h-12">
          <span className="text-[0.725rem] font-medium tracking-widest uppercase 2xl:text-sm">Replica</span>
          <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-[0.85rem] 2xl:text-base">
            You're using <strong>test data</strong>.
          </span>
        </header>
      )}
      <header className="flex w-full grow items-center justify-between bg-slate-900 md:px-2">
        <div className="flex items-center">
          <Button
            className="text-white hover:bg-slate-800 hover:text-white md:hidden [&>svg]:size-4!"
            onClick={() => setOpenMobile(true)}
          >
            <Menu />
          </Button>
          <div className="flex h-10 w-10 items-center justify-center">
            <Logo />
          </div>
        </div>
      </header>
    </div>
  );
};
